import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth.jsx";
import { QuoteMakers, useTracks } from "@/components/QuoteTools";

const localDay = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const DailyQuote = () => {
  const { user } = useAuth();
  const isPro = !!user?.is_premium;
  const tracks = useTracks(isPro);
  const [q, setQ] = useState(null);
  useEffect(() => { api.get("/mindset/daily", { params: { day: localDay() } }).then((r) => setQ(r.data.quote)).catch(() => {}); }, []);
  if (!q) return null;
  return (
    <div className="mt-5 card-panel p-4 border-l-4 border-l-[#FD0F10]" data-testid="daily-quote">
      <div className="flex items-center justify-between">
        <div className="eyebrow text-[#FD0F10]">TODAY'S QUOTE</div>
        <Link to="/mindset" className="text-xs font-mono-ui uppercase tracking-wider text-gray-400 hover:text-white" data-testid="daily-quote-more">More quotes</Link>
      </div>
      <p className="mt-2 text-base sm:text-lg text-white font-display font-bold leading-snug" data-testid="daily-quote-text">"{q.text}"</p>
      <p className="mt-1 text-sm text-[#FD0F10] font-bold" data-testid="daily-quote-author">{q.author}</p>
      <div className="mt-3 flex flex-wrap items-center gap-2" data-testid="daily-quote-makers"><QuoteMakers q={q} isPro={isPro} tracks={tracks} /></div>
    </div>
  );
};
